import type { DomainKey } from '../types';

export const subdomainOverride: Partial<Record<DomainKey, string>> = {};
